import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-primary-key-header',
    templateUrl: './primary-key-header.component.html',
    styleUrls: ['./primary-key-header.component.scss']
})

export class PrimaryKeyHeaderComponent implements IHeaderAngularComp {
    public params: IHeaderParams;
    primaryKeyInfoMsg = '';

    constructor(
        private cvLocalizationService: CVLocalizationService
    ) { }

    refresh(params: IHeaderParams): boolean {
        return false;
    }

    async agInit(params: IHeaderParams): Promise<void> {
        this.params = params;
        try {
            await this.cvLocalizationService.GetSection('ETL_Data_Feed_Create');
        }
        catch {
            console.log('Failed to load localization for ETL_Data_Feed_Create');
        }
        finally {
            this.primaryKeyInfoMsg = this.getLocalizationString("Primary_Key_Info_Msg", "For a field to be the primary key, it must be active.");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Data_Feed_Create", key, defaultValue);
        return baseString;
    }

}
